module.exports = __webpack_public_path__ + "static/media/Directors_Compliance_Update_2024.b7dffff8.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/24-25/Directors_Compliance_Update_2024.pdf
// module id = 238
// module chunks = 0